"use client";

import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function RenovationCtaBand() {
  return <section id="renovationctaband" data-nav="dark" className="relative w-full bg-secondary text-secondary-foreground border-y border-border/20 py-20 md:py-24 overflow-hidden">
      {/* Subtle decorative architectural grid hairlines */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-10 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem]" />

      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        {/* Eyebrow badge */}
        <div className="inline-flex justify-center mb-5">
          <Badge variant="outline" className="border-primary/40 bg-primary/10 text-primary-foreground tracking-wider uppercase text-xs font-semibold px-3.5 py-1 rounded-full">
            START YOUR PROJECT
          </Badge>
        </div>

        {/* Headline */}
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-secondary-foreground max-w-3xl mx-auto leading-tight">
          Ready to plan your Brookhaven whole-home renovation?
        </h2>

        {/* Supporting Copy */}
        <p className="mt-5 text-base sm:text-lg text-secondary-foreground/85 max-w-2xl mx-auto leading-relaxed font-default">
          Connect with our design and construction team to review your architectural goals, discuss timelines, and establish a transparent, fixed-scope budget tailored to your home.
        </p>

        {/* Action Cluster */}
        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-medium px-7 py-6 text-base group">
            <Link to="/ContactRequestAnEstimatePage">
              <span>Request an Estimate</span>
              <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/25 bg-secondary/50 text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground px-6 py-6 text-base font-medium transition-colors">
            <a href="tel:+14708479076" className="inline-flex items-center gap-2">
              <Phone className="size-4 text-primary shrink-0" />
              <span>Call (470) 847-9076</span>
            </a>
          </Button>
        </div>
      </div>
    </section>;
}